const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",

    },
    {
        label: "Operations",
        icon: "mdi mdi-home-variant-outline",
        url: "/operations",
        issubMenubadge: true,

    },
    {
        label: "Track orders",
        icon: "mdi mdi-home-variant-outline",
        url: "/track-orders",
        issubMenubadge: true,

    },
    {
        label: "Returned/Disputes",
        icon: "mdi mdi-home-variant-outline",
        url: "/disputes",
        issubMenubadge: true,

    },
    {
        label: "Stores",
        icon: "mdi mdi-home-variant-outline",
        url: "/stores",
        issubMenubadge: true,

    },
    {
        label: "Riders",
        icon: "mdi mdi-home-variant-outline",
        url: "/riders",
        issubMenubadge: true,

    },
    {
        label: "Users",
        icon: "mdi mdi-home-variant-outline",
        url: "/users",
        issubMenubadge: true,

    },
    {
        label: "Rates",
        icon: "mdi mdi-home-variant-outline",
        url: "/rates",
        issubMenubadge: true,

    },
    {
        label: "Communication",
        icon: "mdi mdi-home-variant-outline",
        url: "/track-orders",
        issubMenubadge: true,

    },
    {
        label: "Templates",
        icon: "mdi mdi-home-variant-outline",
        url: "/track-orders",
        issubMenubadge: true,

    },
   
    {
        label: "Settings",
        icon: "mdi mdi-home-variant-outline",
        url: "/track-orders",
        issubMenubadge: true,

    },
]
export default SidebarData;